import axios from '../../utils/AxiosUtils';
import MessageUtils from "../../utils/MessageUtils";
import {
    LOADING,
    LOAD_RESTAURANT_PRODUCTS_SUCCESS,
    LOAD_PROMOTIONS_SUCCESS,
    SAVE_PROMOTION_SUCCESS,
    UPDATE_PROMOTION_SUCCESS,
    DELETE_PROMOTION_SUCCESS,
    LOAD_PROMOTIONS_SUMMARY_SUCCESS, LOAD_PROMOTIONS_PROMO_CODES_SUCCESS, UPDATE_PROMOTION_IMAGE_SUCCESS,
    DELETE_PROMOTION_IMAGE_SUCCESS,
    LOAD_PROMOTIONS_SEARCH_SUCCESS
} from '../types';
import i18n from '../../i18next';
import _ from "lodash";

export const loadPromotions = (restaurantId, discountType, pageNumber, promoCode) => {
    return (dispatch, getState) => {
        doLoadPromotions(restaurantId, discountType, false, dispatch, getState, pageNumber, promoCode);
    }
}

export const doLoadPromotions = (restaurantId, discountType, summaryParam, dispatch, getState, pageNumber, promoCode) => {
    dispatch({ type: LOADING, payload: true });

    const updatedQuery = getQueryParams(pageNumber, restaurantId, discountType, promoCode)
    const url = `restaurant/search-promotions?${updatedQuery}`;

    if (summaryParam) {
        axios().get(url)
            .then(response => loadPromotionsSummarySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.summaryFail')));
    } else {
        axios().get(url)
            .then(response => loadPromotionsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.promotionsFail')));
    }
}

const loadPromotionsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_PROMOTIONS_SUCCESS, payload: response.data.content });
    dispatch({ type: LOAD_PROMOTIONS_SEARCH_SUCCESS, payload: response.data });
}

export const loadPromotionsSummary = (restaurantId, discountType, pageNumber, promoCode) => {
    return (dispatch, getState) => {
        // Calls getAllPromotions service second time so that summary items do not change on performing search.
        // It has its own reducer, so data won't be replaced.
        doLoadPromotions(restaurantId, discountType, true, dispatch, getState, pageNumber, promoCode);
    }
}

const loadPromotionsSummarySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_PROMOTIONS_SUMMARY_SUCCESS, payload: response.data.content });
    dispatch({ type: LOAD_PROMOTIONS_SEARCH_SUCCESS, payload: response.data });
}

export const loadRestaurantProducts = (restaurantId, activeOnly, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const activeOnlyQuery = activeOnly ? `?activeOnly=${activeOnly}` : ''

        const url = `/restaurant/${restaurantId}/products${activeOnlyQuery}`;

        axios().get(url)
            .then(response => loadRestaurantProductsSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadProductsFailure')));
    }
};

const loadRestaurantProductsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANT_PRODUCTS_SUCCESS, payload: response.data });
    callback();
};

export const savePromotion = (restaurantId, promotion, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/promotion`;

        let promotionData = _.pick(promotion, ['promoCodeFromExternalSource', 'promoCodeUsageType', 'promoCodeValues']);

        if (promotionData.promoCodeUsageType == '') {
            let newPromotion = Object.assign({}, promotion);

            newPromotion.promoCodeFromExternalSource = true;
            newPromotion.promoCodeUsageType = null;
            newPromotion.promoCodeValues = null;

            promotion = newPromotion;
        }

        let formDataForImage = promotion.formData;
        delete promotion.imagePreview; // deleting these two properties allows successfull requests - it is needed here so that I can have form data passed correctly
        delete promotion.formData;

        axios().post(url, promotion)
            .then(response => savePromotionSuccess(dispatch, response, callback, getState, formDataForImage))
            // .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadProductsFailure')));
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.saveFail')));
    }
};

const savePromotionSuccess = (dispatch, response, callback, getState, formData) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: SAVE_PROMOTION_SUCCESS, payload: response.data });

    if (!formData) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.saveSuccess'));
    }
    callback();
    const promotionId = response.data.id;
    if (formData !== undefined && formData !== null) {
        doUploadPromotionImage(promotionId, formData, dispatch, getState);
    }
};

export const updatePromotion = (promotionId, restaurantId, promotion, callback, formData) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        delete promotion.imagePreview; // deleting these two properties allows successfull requests - it is needed here so that I can have form data passed correctly
        delete promotion.formData;

        const url = `/promotion/${promotionId}`;

        axios().put(url, promotion)
            .then(response => updatePromotionSuccess(dispatch, response, restaurantId, callback, promotionId, formData, getState))
            // .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadProductsFailure')));
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.saveFail')));
    }
};

const updatePromotionSuccess = (dispatch, response, undefined, callback, promotionId, formData, getState) => {
    const updateMsg = true;
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_PROMOTION_SUCCESS, payload: response.data });
    if (!formData) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.updateSuccess'));
    }

    if (formData) {
        doUploadPromotionImage(promotionId, formData, dispatch, getState, updateMsg);
    }
    callback();
};

// Delete Promotion
export const deletePromotion = (promotionId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/promotion/${promotionId}`;

        axios().delete(url)
            .then(response => deletePromotionSuccess(dispatch, response, promotionId, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.deleteFail')));
    }
};

const deletePromotionSuccess = (dispatch, response, promotionId, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: DELETE_PROMOTION_SUCCESS, payload: promotionId });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.deleteSuccess'));
    callback();
};

export const generatePromotionCodes = (quantity, restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/promo-code/generate?quantity=${quantity}&restaurantId=${restaurantId}`;

        axios().get(url)
            .then(response => generatePromotionCodesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.generateCodesFail')));
    }
}

const generatePromotionCodesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_PROMOTIONS_PROMO_CODES_SUCCESS, payload: response.data.data });
}


export const uploadPromotionImage = (promotionId, formData) => {
    return (dispatch, getState) => {
        doUploadPromotionImage(promotionId, formData, dispatch, getState);
    }
}

const doUploadPromotionImage = (promotionId, formData, dispatch, getState, updateMsg) => {
    const newFormData = new FormData();
    newFormData.append('file', formData);

    const url = `/promotion/${promotionId}/upload-image`;
    const header = { headers: { 'Content-Type': 'multipart/form-data' } }

    axios().put(url, newFormData, header)
        .then(response => uploadPromotionImageSuccess(dispatch, response, updateMsg))
        .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:promotionsActions.uploadImageFailure')));
}

const uploadPromotionImageSuccess = (dispatch, response, updateMsg) => {
    dispatch({ type: UPDATE_PROMOTION_IMAGE_SUCCESS, payload: response.data });
    if (updateMsg) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.updateSuccess'));
    } else {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.saveSuccess'));
    }
}

export const deletePromotionImage = (imageId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/promotion/${imageId}/delete-image`;

        axios().put(url, {})
            .then(response => deletePromotionImageSuccess(dispatch, response, imageId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:promotionsActions.deleteImageFail')));
    }
};

const deletePromotionImageSuccess = (dispatch, promotionImageId) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: DELETE_PROMOTION_IMAGE_SUCCESS, payload: promotionImageId });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:promotionsActions.deleteImageSuccess'));
};

const getQueryParams = (pageNumber, restaurantId, discountType, promoCode) => {

    let pageParam = '',
        sizeParam = '',
        restaurantIdParam = '',
        discountTypeParam = '',
        promoCodeParam = '';

    pageParam = pageNumber;
    sizeParam = 10; // backend default 20


    if (restaurantId) {
        restaurantIdParam = `&id=${restaurantId}`
    }

    if (discountType) {
        discountTypeParam = `&discountType=${discountType}`
    }

    if (promoCode && promoCode !== '') {
        promoCodeParam = `&promoCode=${promoCode}`
    }

    return `page=${pageParam}&size=${sizeParam}${restaurantIdParam}${discountTypeParam}${promoCodeParam}`;
}


// WEBPACK FOOTER //
// ./src/actions/promotions/PromotionsActions.js